import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/core/services/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-profil',
  templateUrl: './profil.component.html',
  styleUrls: ['./profil.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProfilComponent implements OnInit {

  activeSection: 'profil' | 'password' = 'profil';
  utilisateur: any = null;
  profilForm: FormGroup;
  motPasseForm: FormGroup;
  chargement = false;
  photoUrl = 'assets/images/avatar-default.svg';

  masquerAncienMotPasse = true;
  masquerNouveauMotPasse = true;
  masquerConfirmationMotPasse = true;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private snackBar: MatSnackBar
  ) {
    this.profilForm = this.fb.group({
      nom: ['', Validators.required],
      prenom: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      contact: ['', Validators.required],
      adresse: ['']
    });

    this.motPasseForm = this.fb.group({
      ancienMotPasse: ['', Validators.required],
      nouveauMotPasse: ['', [Validators.required, Validators.minLength(6)]],
      confirmationMotPasse: ['', Validators.required]
    }, {
      validators: this.motPasseIdentique
    });
  }

  ngOnInit(): void {
    this.chargerProfil();
  }

  switchSection(section: 'profil' | 'password'): void {
    this.activeSection = section;
  }

  chargerProfil(): void {
    this.utilisateur = this.authService.obtenirUtilisateurCourant();
    if (this.utilisateur) {
      this.profilForm.patchValue({
        nom: this.utilisateur.nom || '',
        prenom: this.utilisateur.prenom || '',
        email: this.utilisateur.email || '',
        contact: this.utilisateur.contact || '',
        adresse: this.utilisateur.adresse || ''
      });
    }
  }

  motPasseIdentique(group: FormGroup): { [key: string]: boolean } | null {
    const nouveau = group.get('nouveauMotPasse')?.value;
    const confirmation = group.get('confirmationMotPasse')?.value;
    return nouveau === confirmation ? null : { motPasseNonIdentique: true };
  }

  onFileSelect(event: any): void {
    const fichier = event.target.files[0];
    if (fichier) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.photoUrl = e.target.result;
      };
      reader.readAsDataURL(fichier);
    }
  }

  sauvegarderProfil(): void {
    if (this.profilForm.valid) {
      this.chargement = true;
      console.log('Données du profil:', this.profilForm.value);
      
      setTimeout(() => {
        this.chargement = false;
        this.snackBar.open('Profil mis à jour avec succès', 'Fermer', {
          duration: 3000,
          horizontalPosition: 'right',
          verticalPosition: 'top',
          panelClass: ['success-snackbar']
        });
      }, 1000);
    }
  }

  changerMotPasse(): void {
    if (this.motPasseForm.valid) {
      this.chargement = true;
      console.log('Changement de mot de passe');
      
      setTimeout(() => {
        this.chargement = false;
        this.motPasseForm.reset();
        this.snackBar.open('Mot de passe modifié avec succès', 'Fermer', {
          duration: 3000,
          horizontalPosition: 'right',
          verticalPosition: 'top',
          panelClass: ['success-snackbar']
        });
      }, 1000);
    }
  }

  getLibelleRole(): string {
    const roleMap: { [key: string]: string } = {
      'ADMIN': 'Administrateur',
      'MANAGER': 'Manager',
      'USER': 'Utilisateur',
      'LIVREUR': 'Livreur'
    };
    return roleMap[this.utilisateur?.role] || this.utilisateur?.role || 'Utilisateur';
  }
}
